<template>
  <div class="rg-cn">
    <h3 class="dialog-title">
      <p><span></span>任务信息</p>
    </h3>
    <div class="dialog-content" style="padding:0 10px">
      <el-table border :data="orderDetail.subOrders" style="width: 100%">
        <el-table-column type="expand">
          <template v-slot='scope' class="inner">
            <div style="width:100%;height:100%">
              <el-table border :data="scope.row.orderItems">
                <el-table-column label="任务号" prop="id"></el-table-column>
                <el-table-column label="sku名称" prop="skuName"></el-table-column>
                <el-table-column label="属性组合" prop="skuGroupName"></el-table-column>
                <el-table-column label="P数" prop="page"></el-table-column>
                <el-table-column label="数量" prop="quantity"></el-table-column>
                <el-table-column label="任务状态">
                  <template slot-scope="scope">
                    <span>{{ $config.orderItemStatus[scope.row.orderItemStatus] }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="子订单号" prop="suborderNo"></el-table-column>
        <el-table-column label="产品名称" prop="spuName"></el-table-column>
        <el-table-column label="属性组合" prop="skuGroupName"></el-table-column>
        <el-table-column label="数量" prop="quantity"></el-table-column>
        <el-table-column label="客户名称" prop="personalMessage"></el-table-column>
        <el-table-column label="收货人" prop="address.person"></el-table-column>
        <el-table-column label="收货电话" prop="address.phone">
          <template slot-scope="scope">
            <span>{{ $msg.filterBridal(scope.row.address.phone) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="收货地址" prop="address.completeAddress"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { adminOrder } from '@/api/oms'
export default {
  name: 'order-item',
  props: ['orderNo'],
  data () {
    return {
      orderDetail: {},
      storeInfo: {}
    }
  },
  created () {
    this.orderNo && this.getOrderDetail()
  },
  methods: {
    getOrderDetail () {
      adminOrder(this.orderNo).then(res => {
        if (res.data.success) {
          this.orderDetail = res.data.data
          this.storeInfo = {
            storeCode: this.orderDetail.storeCode,
            storeName: this.orderDetail.storeName,
            storePhone: this.orderDetail.storePhone,
            storeAddress: this.orderDetail.storeAddress
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.dialog-title {
  margin-bottom: 15px;
  height: 78px;
  background: inherit;
  background-color: rgba(250, 250, 250, 1);
  position: relative;

  p {
    line-height: 78px;
    padding-left: 50px;

    span {
      position: relative;
      top: -2px;
      display: inline-block;
      background: #409eff;
      width: 7px;
      height: 18px;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
}
</style>
